import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const SkeletonNewProducts = () => {
    return (
        <div className="skeleton-new-products-wrapper xmt-20">
            <div className="container">
                <div className="more-icon d-flex justify-content-end"><IconName name="chevron_left" className="icon"/></div>
                <div className="border-new-products xmt-2 skeleton-loading"></div>
                <div className="products-box d-flex xmt-6">
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                </div>

                <div className="products-box product-box--2 d-flex xmt-6">
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                    <div className="product skeleton-loading">
                        <div className="circle skeleton-loading"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonNewProducts;
